/**
 * @generated SignedSource<<1dc48e0468dafdff9d8527190d4c856b>>
 * @relayHash 255bf1f3827e592cb2a13b3ebec4026e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6d6128157de23583fdf95be9b30eccb893f9fa157c7b8ceaebbc13444f031c50

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraAtlassianIntelligenceFeatureEnum = "AI_MATE" | "NATURAL_LANGUAGE_TO_JQL" | "%future added value";
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_BOARD" | "TIMELINE_PROJECT" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null;
  customInput?: JiraIssueSearchCustomInput | null;
  filterId?: string | null;
  groupByInput?: JiraIssueSearchGroupByInput | null;
  jql?: string | null;
  searchWithLastUsedJql?: boolean | null;
};
export type JiraIssueSearchChildIssuesInput = {
  applyJqlFilter?: boolean | null;
  filterByProjectKeys?: ReadonlyArray<string> | null;
  filterId?: string | null;
  jql?: string | null;
  namespace?: string | null;
  parentIssueKey: string;
  viewId?: string | null;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null;
  context?: JiraSoftwareIssueSearchCustomInputContext | null;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null;
  hideUnParentedItems?: boolean | null;
  maxHierarchyLevel?: number | null;
  quickFilterIds?: ReadonlyArray<string> | null;
  useSavedFilters?: boolean | null;
};
export type JiraIssueSearchGroupByInput = {
  groupByJql?: string | null;
  jql?: string | null;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null;
  viewInput?: JiraIssueSearchViewInput | null;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null;
  filterId?: string | null;
  namespace?: string | null;
  viewId?: string | null;
};
export type JiraIssueSearchViewFieldSetsContext = {
  filterContext?: JiraIssueSearchViewFieldSetFilterContext | null;
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null;
};
export type JiraIssueSearchViewFieldSetFilterContext = {
  filter?: string | null;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null;
  project?: string | null;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null;
  isGroupingEnabled?: boolean | null;
  isHideDoneEnabled?: boolean | null;
  isHierarchyEnabled?: boolean | null;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null;
  canEnableAggregation?: boolean | null;
  fieldAggregationQueryInput?: JiraFieldAggregationQueryInput | null;
  maxHierarchyLevel?: number | null;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null;
  fieldId?: string | null;
  isEnabled?: boolean | null;
};
export type JiraFieldAggregationQueryInput = {
  boardQuery?: JiraFieldAggregationByBoardQuery | null;
  projectQuery?: JiraFieldAggregationByProjectQuery | null;
  viewId?: string | null;
};
export type JiraFieldAggregationByBoardQuery = {
  boardId: AGG$Long;
  cloudId: string;
};
export type JiraFieldAggregationByProjectQuery = {
  cloudId: string;
  projectIdOrKey: JiraFieldAggregationProjectIdOrKeyInput;
};
export type JiraFieldAggregationProjectIdOrKeyInput = {
  projectId?: AGG$Long | null;
  projectKey?: string | null;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null;
  viewInput?: JiraIssueSearchViewInput | null;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null;
  projectKey?: string | null;
};
export type JiraViewQueryInput = {
  boardIdAndItemQuery?: JiraViewBoardIdAndItemQuery | null;
  projectKeyAndItemQuery?: JiraViewProjectKeyAndItemQuery | null;
  subcontainerIdAndItemQuery?: JiraViewSubcontainerIdAndItemQuery | null;
  viewId?: string | null;
};
export type JiraViewBoardIdAndItemQuery = {
  boardId: AGG$Long;
  cloudId: string;
  itemId: string;
};
export type JiraViewProjectKeyAndItemQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type JiraViewSubcontainerIdAndItemQuery = {
  cloudId: string;
  itemId: string;
  subcontainerId: string;
};
export type JiraIssueSearchSettings = {
  groupBy?: string | null;
  hideDone?: boolean | null;
  hierarchyEnabled?: boolean | null;
  jql?: string | null;
};
export type main_IssueNavigatorQuery$variables = {
  after?: string | null;
  amountOfColumns: number;
  atlassianIntelligenceProductFeature: JiraAtlassianIntelligenceFeatureEnum;
  before?: string | null;
  cloudId: string;
  dynamicSearchKey?: string | null;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null;
  fieldSetsScope?: JiraIssueSearchScope | null;
  filterId?: string | null;
  first?: number | null;
  groupBy?: string | null;
  isPaginating?: boolean | null;
  issueSearchInput: JiraIssueSearchInput;
  jiraViewQueryInput?: JiraViewQueryInput | null;
  last?: number | null;
  namespace?: string | null;
  options?: JiraIssueSearchOptions | null;
  projectKey: string;
  saveJQLToUserHistory?: boolean | null;
  scope?: JiraIssueSearchScope | null;
  settings?: JiraIssueSearchSettings | null;
  shouldQueryConditionalFormatting: boolean;
  shouldQueryConditionalFormattingFromSavedView: boolean;
  shouldQueryHasChildren?: boolean | null;
  shouldQueryHasChildrenWithCount?: boolean | null;
  shouldQueryProject: boolean;
  shouldQueryRankField?: boolean | null;
  shouldQuerySaveResetViewSettingsButton: boolean;
  staticViewInput?: JiraIssueSearchStaticViewInput | null;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null;
  viewId?: string | null;
};
export type main_IssueNavigatorQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey?: {
      readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingInner" | "ConditionalFormattingSidebarContainer_project" | "IssueNavigatorUIComponent_project_jiraProject" | "IssueSearch_issueNavigatorProject">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"main_IssueNavigatorIssueNavigator_IssueNavigator_jira">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"main_IssueNavigatorIssueNavigator_IssueNavigator_issueQuery">;
};
export type main_IssueNavigatorQuery = {
  response: main_IssueNavigatorQuery$data;
  variables: main_IssueNavigatorQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider": isOrderByRankEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": isSavedViewConditionalFormattingEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider": isNinDecoupledJqlValidationFieldEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider": isNinIssuePreviewPanelChangeboardingEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled": isIssueSearchWarningsEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": isFieldCellExtractionEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": isUseNodeIdForRowKeyDisabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": isColouredDueDateUiChangesEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": shouldFetchDelegatorForList_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldFetchDelegator_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": shouldSurfaceAgentAssignee_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": isFrontierFormulaFieldD2D3Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": isJiraForgeCustomFieldsInIssueNavigatorEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": isFrontierFormulaFieldNinEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": isJscInlineEditFastFollowsEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": isColorFieldEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": isDateRangeFieldEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": isUseNodeIdForRowKeyEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": cmdbFirst_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": caterRichTextWithPlainTextRenderer_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": isPrivateGoalsFieldReadEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": isProjectsInJiraGaDropEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled": isJiraSpreadsheetGroupSearchWarningsEnabled_provider,
  "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider": isProjectsInJiraM1Enabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider,
  "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider": isPrivateGoalsInListViewGroupHeaderEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider": isAdditionalFieldsInGroupByProjectHeaderEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsJSCExpandAllChangesEnabledRelayprovider": isJSCExpandAllChangesEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider": isPaidListNinMergeOnboardingModalEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": isGuidedAutonomyEapEnabled_provider
} as {
  readonly __relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsJSCExpandAllChangesEnabledRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider: {
    readonly get: () => number | null;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider: {
    readonly get: () => boolean;
  };
});

import isPrivateGoalsInListViewGroupHeaderEnabled_provider from '@jira/issue-table__grouping/src/relay-provider/PrivateGoalsInJiraRelayProvider';
import isProjectsInJiraM1Enabled_provider from '@jira/issue-table__grouping/src/relay-provider/projects-in-jira-m1.relayprovider';
import shouldFetchDelegatorForList_provider from '@jira/platform__graphql-relay-provider/src/EmpanadaAssigneeAgentDelegateFixRelayprovider';
import isFrontierFormulaFieldD2D3Enabled_provider from '@jira/platform__graphql-relay-provider/src/FrontierFormulaFieldD2D3Relayprovider';
import isGuidedAutonomyEapEnabled_provider from '@jira/platform__graphql-relay-provider/src/FrontierGuidedAutonomyEapRelayProvider';
import isJSCExpandAllChangesEnabled_provider from '@jira/platform__graphql-relay-provider/src/IsJSCExpandAllChangesEnabledRelayprovider';
import isDateRangeFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/IssueTableDateRangeFieldRelayProvider';
import isColouredDueDateUiChangesEnabled_provider from '@jira/platform__graphql-relay-provider/src/JivColouredDueDateUiChangesRelayprovider';
import shouldSurfaceAgentAssignee_provider from '@jira/platform__graphql-relay-provider/src/JsmSurfaceAgentAssigneeRelayProvider';
import caterRichTextWithPlainTextRenderer_provider from '@jira/platform__graphql-relay-provider/src/NinCaterRichTextWithPlainTextRendererRelayProvider';
import isFieldCellExtractionEnabled_provider from '@jira/platform__graphql-relay-provider/src/NinFieldCellExtractionRelayProvider';
import isPrivateGoalsFieldReadEnabled_provider from '@jira/platform__graphql-relay-provider/src/PrivateGoalsInJiraRelayProvider';
import isUseNodeIdForRowKeyDisabled_provider from '@jira/platform__graphql-relay-provider/src/UseNodeIdForRowKeyDisabledRelayProvider';
import isAdditionalFieldsInGroupByProjectHeaderEnabled_provider from '@jira/platform__graphql-relay-provider/src/additionalFieldsInGroupByProjectHeaderRelayProvider';
import cmdbFirst_provider from '@jira/platform__graphql-relay-provider/src/assets-custom-fields-limit-increase.relayprovider';
import isAtlasProjectEnabled_provider from '@jira/platform__graphql-relay-provider/src/atlas-project-native-integration.relayprovider';
import isFormulaFieldD1Enabled_provider from '@jira/platform__graphql-relay-provider/src/frontier-formula-field-d1.relayprovider';
import isFrontierFormulaFieldNinEnabled_provider from '@jira/platform__graphql-relay-provider/src/frontier-formula-field-nin.relayprovider';
import isHexagonSupportEnabled_provider from '@jira/platform__graphql-relay-provider/src/hexagon-support.relayprovider';
import isInitialiseVirtualiserStateFromRelayStoreEnabled_provider from '@jira/platform__graphql-relay-provider/src/initialise-virtualiser-state-from-relay-store.relayprovider';
import isIframePreviewPanelInSubtasksEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-iframe-preview-panel-in-subtasks-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@jira/platform__graphql-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isPaidListNinMergeOnboardingModalEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-jira-paid-list-nin-merge-onboarding-modal-enabled.relayprovider';
import isJscIFCEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isJscInlineEditFastFollowsEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-jsc-inline-edit-fast-follows-enabled.relayprovider';
import isSavedViewConditionalFormattingEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-saved-list-view-conditional-formatting-enabled.relayprovider';
import isSavedListViewEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-saved-list-view-enabled.relayprovider';
import isSavedListViewTechnicalChangesEnabled_provider from '@jira/platform__graphql-relay-provider/src/is-saved-list-view-technical-changes-enabled.relayprovider';
import isIssueSearchWarningsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isIssueSearchWarningsEnabled';
import isJiraForgeCustomFieldsInIssueNavigatorEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJiraForgeCustomFieldsInIssueNavigatorEnabled.relayprovider';
import isJiraSpreadsheetGroupSearchWarningsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJiraSpreadsheetGroupSearchWarningsEnabled';
import isNinIssuePreviewPanelChangeboardingEnabled_provider from '@jira/platform__graphql-relay-provider/src/isNinIssuePreviewPanelChangeboardingEnabledRelayProvider';
import isColorFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/issue-table-color-field.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider from '@jira/platform__graphql-relay-provider/src/jira-ai-agent-avatar-single-user-picker-nin.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@jira/platform__graphql-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldFetchDelegator_provider from '@jira/platform__graphql-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@jira/platform__graphql-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isMimicFlatlistRssWhileUninitialisedEnabled_provider from '@jira/platform__graphql-relay-provider/src/mimic-flatlist-rss-while-uninitialised.relayprovider';
import isNinDecoupledJqlValidationFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/nin-decoupled-jql-validation-field.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@jira/platform__graphql-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';
import isOrderByRankEnabled_provider from '@jira/platform__graphql-relay-provider/src/pnin-jql-order-by-rank.relayprovider';
import isProjectsInJiraGaDropEnabled_provider from '@jira/platform__graphql-relay-provider/src/projectsInJiraGaDropRelayProvider';
import isUseNodeIdForRowKeyEnabled_provider from '@jira/platform__graphql-relay-provider/src/use-node-id-for-row-key.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianIntelligenceProductFeature"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dynamicSearchKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsScope"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPaginating"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraViewQueryInput"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "saveJQLToUserHistory"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settings"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryConditionalFormatting"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryConditionalFormattingFromSavedView"
},
v23 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildren"
},
v24 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildrenWithCount"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryProject"
},
v26 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldQueryRankField"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQuerySaveResetViewSettingsButton"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v31 = {
  "kind": "Variable",
  "name": "isConditionalFormattingEnabled",
  "variableName": "shouldQueryConditionalFormatting"
},
v32 = {
  "kind": "Variable",
  "name": "isSavedViewConditionalFormattingEnabled",
  "variableName": "shouldQueryConditionalFormattingFromSavedView"
},
v33 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v34 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v35 = [
  (v34/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v36 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v37 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v38 = {
  "kind": "Variable",
  "name": "jiraViewQueryInput",
  "variableName": "jiraViewQueryInput"
},
v39 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v40 = {
  "kind": "Variable",
  "name": "settings",
  "variableName": "settings"
},
v41 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v42 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v43 = {
  "kind": "ScalarField",
  "name": "message"
},
v44 = [
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      (v41/*: any*/),
      (v42/*: any*/)
    ]
  },
  (v43/*: any*/)
],
v45 = {
  "kind": "ScalarField",
  "name": "id"
},
v46 = {
  "kind": "ScalarField",
  "name": "jql"
},
v47 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "fieldSetsScope"
},
v48 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "fieldSetSelectedState": "SELECTED"
    }
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "amountOfColumns"
  },
  (v47/*: any*/)
],
v49 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v50 = {
  "kind": "ScalarField",
  "name": "savedViewId"
},
v51 = {
  "args": [
    (v40/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "isViewConfigModified"
},
v52 = {
  "kind": "Variable",
  "name": "groupBy",
  "variableName": "groupBy"
},
v53 = [
  (v52/*: any*/),
  (v37/*: any*/),
  (v40/*: any*/),
  {
    "kind": "Variable",
    "name": "staticViewInput",
    "variableName": "staticViewInput"
  }
],
v54 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v55 = {
  "concreteType": "JiraSpreadsheetGroupByConfig",
  "kind": "LinkedField",
  "name": "groupByConfig",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraField",
      "kind": "LinkedField",
      "name": "groupByField",
      "plural": false,
      "selections": [
        (v54/*: any*/),
        (v45/*: any*/)
      ]
    }
  ]
},
v56 = {
  "kind": "ScalarField",
  "name": "hideDone"
},
v57 = {
  "kind": "ScalarField",
  "name": "isHierarchyEnabled"
},
v58 = {
  "kind": "ScalarField",
  "name": "__id"
},
v59 = {
  "kind": "ClientExtension",
  "selections": [
    (v58/*: any*/)
  ]
},
v60 = {
  "kind": "Variable",
  "name": "saveJQLToUserHistory",
  "variableName": "saveJQLToUserHistory"
},
v61 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v62 = {
  "kind": "ScalarField",
  "name": "canEnableHierarchy"
},
v63 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v64 = {
  "kind": "ScalarField",
  "name": "type"
},
v65 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v66 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v67 = {
  "kind": "ScalarField",
  "name": "aliases"
},
v68 = {
  "kind": "ScalarField",
  "name": "value"
},
v69 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/),
    {
      "alias": "singleValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    },
    (v68/*: any*/)
  ],
  "type": "JiraFormattingSingleValueOperand"
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/),
    {
      "alias": "multipleValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    },
    {
      "kind": "ScalarField",
      "name": "values"
    }
  ],
  "type": "JiraFormattingMultipleValueOperand"
},
v71 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/),
    {
      "alias": "noValueOperator",
      "kind": "ScalarField",
      "name": "operator"
    }
  ],
  "type": "JiraFormattingNoValueOperand"
},
v72 = {
  "kind": "LinkedField",
  "name": "expression",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v69/*: any*/),
    (v70/*: any*/),
    (v71/*: any*/)
  ]
},
v73 = {
  "kind": "ScalarField",
  "name": "formattingArea"
},
v74 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v75 = [
  {
    "concreteType": "JiraFormattingRuleEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraFormattingRule",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v72/*: any*/),
          (v73/*: any*/),
          {
            "concreteType": "JiraColor",
            "kind": "LinkedField",
            "name": "formattingColor",
            "plural": false,
            "selections": [
              (v45/*: any*/),
              (v74/*: any*/)
            ]
          },
          (v45/*: any*/)
        ]
      }
    ]
  }
],
v76 = [
  (v74/*: any*/),
  (v45/*: any*/)
],
v77 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "formattingColor",
  "plural": false,
  "selections": (v76/*: any*/)
},
v78 = {
  "kind": "ScalarField",
  "name": "name"
},
v79 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v80 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v81 = {
  "kind": "Variable",
  "name": "fieldSetsInput",
  "variableName": "fieldSetsInput"
},
v82 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v83 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v84 = {
  "kind": "Variable",
  "name": "options",
  "variableName": "options"
},
v85 = [
  (v79/*: any*/),
  (v80/*: any*/),
  (v81/*: any*/),
  (v82/*: any*/),
  (v37/*: any*/),
  (v83/*: any*/),
  (v84/*: any*/),
  (v60/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/)
],
v86 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v87 = {
  "kind": "ScalarField",
  "name": "key"
},
v88 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v89 = [
  (v78/*: any*/),
  (v45/*: any*/)
],
v90 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v91 = {
  "kind": "ScalarField",
  "name": "text"
},
v92 = {
  "kind": "ScalarField",
  "name": "picture"
},
v93 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUser"
},
v94 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "appType"
    }
  ],
  "type": "AppUser"
},
v95 = [
  (v93/*: any*/),
  (v94/*: any*/)
],
v96 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v97 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v98 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v97/*: any*/),
    (v45/*: any*/)
  ]
},
v99 = {
  "kind": "InlineFragment",
  "selections": [
    (v98/*: any*/)
  ],
  "type": "JiraStatusCategoryField"
},
v100 = {
  "concreteType": "JiraIssueEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    (v86/*: any*/),
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v41/*: any*/),
        (v45/*: any*/),
        (v87/*: any*/),
        (v88/*: any*/),
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraIssueTypeField",
              "kind": "LinkedField",
              "name": "issueTypeField",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": (v89/*: any*/)
                },
                (v45/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "args": (v90/*: any*/),
      "concreteType": "JiraIssueFieldSetConnection",
      "kind": "LinkedField",
      "name": "fieldSets",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldConnection",
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v54/*: any*/),
                            (v41/*: any*/),
                            (v64/*: any*/),
                            (v45/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v91/*: any*/),
                                (v78/*: any*/)
                              ],
                              "type": "JiraSingleLineTextField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v78/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "name": "user",
                                  "plural": false,
                                  "selections": [
                                    (v41/*: any*/),
                                    (v78/*: any*/),
                                    (v92/*: any*/),
                                    (v45/*: any*/),
                                    {
                                      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider",
                                      "kind": "Condition",
                                      "passingValue": true,
                                      "selections": (v95/*: any*/)
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraSingleSelectUserPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraIssueType",
                                  "kind": "LinkedField",
                                  "name": "issueType",
                                  "plural": false,
                                  "selections": [
                                    (v78/*: any*/),
                                    (v96/*: any*/),
                                    (v45/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraIssueTypeField"
                            },
                            (v99/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "fieldSets(first:500)"
    },
    (v41/*: any*/)
  ]
},
v101 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v102 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v103 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v101/*: any*/),
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    (v102/*: any*/),
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    }
  ]
},
v104 = {
  "concreteType": "JiraIssueNavigatorPageInfo",
  "kind": "LinkedField",
  "name": "issueNavigatorPageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "firstIssuePosition"
    }
  ]
},
v105 = [
  {
    "kind": "Literal",
    "name": "maxCursors",
    "value": 7
  }
],
v106 = {
  "kind": "ScalarField",
  "name": "pageNumber"
},
v107 = [
  (v106/*: any*/)
],
v108 = {
  "args": (v105/*: any*/),
  "concreteType": "JiraPageCursors",
  "kind": "LinkedField",
  "name": "pageCursors",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "around",
      "plural": true,
      "selections": (v107/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "last",
      "plural": false,
      "selections": (v107/*: any*/)
    }
  ],
  "storageKey": "pageCursors(maxCursors:7)"
},
v109 = {
  "kind": "ScalarField",
  "name": "totalIssueSearchResultCount"
},
v110 = [
  (v43/*: any*/)
],
v111 = {
  "kind": "LinkedField",
  "name": "issueSearchError",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "messages"
        }
      ],
      "type": "JiraInvalidJqlError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v43/*: any*/),
        (v61/*: any*/)
      ],
      "type": "JiraInvalidSyntaxError"
    },
    {
      "kind": "InlineFragment",
      "selections": (v110/*: any*/),
      "type": "JiraServerError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v43/*: any*/),
        (v42/*: any*/)
      ],
      "type": "JiraInvalidIssueSearchInputError"
    }
  ]
},
v112 = {
  "kind": "ScalarField",
  "name": "isCappingIssueSearchResult"
},
v113 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v114 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v115 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v114/*: any*/),
        (v45/*: any*/),
        (v78/*: any*/),
        (v96/*: any*/)
      ]
    },
    (v45/*: any*/)
  ]
},
v116 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraListRow"
},
v117 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v98/*: any*/),
    (v45/*: any*/)
  ]
},
v118 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    (v117/*: any*/),
    (v45/*: any*/)
  ]
},
v119 = {
  "kind": "ScalarField",
  "name": "summary"
},
v120 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v121 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v122 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "resolutionPlanAssigneeProperty",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "jsm_resolution_plan_property"
            }
          ],
          "kind": "ScalarField",
          "name": "issuePropertyByKey",
          "storageKey": "issuePropertyByKey(key:\"jsm_resolution_plan_property\")"
        },
        {
          "concreteType": "JiraProjectField",
          "kind": "LinkedField",
          "name": "projectField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v120/*: any*/),
                (v45/*: any*/)
              ]
            },
            (v45/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "delegator",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v78/*: any*/),
            (v121/*: any*/),
            (v92/*: any*/),
            (v45/*: any*/)
          ]
        }
      ]
    }
  ]
},
v123 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v59/*: any*/)
          ],
          "type": "JiraListRow",
          "abstractKey": "__isJiraListRow"
        },
        (v122/*: any*/),
        (v59/*: any*/)
      ],
      "type": "JiraIssue"
    }
  ]
},
v124 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v122/*: any*/)
      ],
      "type": "JiraIssue"
    }
  ]
},
v125 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isHighlightedIssueRow"
        }
      ]
    }
  ],
  "type": "JiraIssue"
},
v126 = {
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v113/*: any*/),
    (v115/*: any*/),
    (v116/*: any*/),
    (v118/*: any*/),
    (v119/*: any*/),
    (v123/*: any*/),
    (v59/*: any*/),
    (v124/*: any*/),
    (v125/*: any*/)
  ]
},
v127 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraListRowEdge"
},
v128 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraListRowFieldSetConnection"
},
v129 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraListRowFieldSet"
},
v130 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v131 = {
  "kind": "ClientExtension",
  "selections": [
    (v130/*: any*/)
  ]
},
v132 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v78/*: any*/),
                (v45/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v133 = [
  (v68/*: any*/),
  (v45/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v134 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "concreteType": "JiraCascadingOption",
      "kind": "LinkedField",
      "name": "cascadingOption",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "parentOptionValue",
          "plural": false,
          "selections": (v133/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "childOptionValue",
          "plural": false,
          "selections": (v133/*: any*/)
        }
      ]
    },
    (v131/*: any*/)
  ],
  "type": "JiraCascadingSelectField"
},
v135 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
        }
      ],
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": (v110/*: any*/)
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v136 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v137 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v138 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v139 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "args": (v136/*: any*/),
      "concreteType": "JiraComponentConnection",
      "kind": "LinkedField",
      "name": "selectedComponentsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraComponent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v137/*: any*/),
                (v138/*: any*/),
                (v45/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedComponentsConnection(first:1000)"
    },
    (v131/*: any*/)
  ],
  "type": "JiraComponentsField"
},
v140 = {
  "kind": "ScalarField",
  "name": "date"
},
v141 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v142 = {
  "kind": "InlineFragment",
  "selections": [
    (v140/*: any*/),
    (v78/*: any*/),
    (v141/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v143 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v144 = {
  "kind": "InlineFragment",
  "selections": [
    (v143/*: any*/),
    (v78/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v145 = {
  "kind": "ScalarField",
  "name": "formattedText"
},
v146 = {
  "kind": "ScalarField",
  "name": "number"
},
v147 = [
  (v78/*: any*/)
],
v148 = {
  "concreteType": "JiraLabelEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraLabel",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v147/*: any*/)
    }
  ]
},
v149 = {
  "kind": "ScalarField",
  "name": "groupId"
},
v150 = [
  (v41/*: any*/),
  (v121/*: any*/),
  (v78/*: any*/),
  (v92/*: any*/),
  (v45/*: any*/)
],
v151 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v143/*: any*/),
        (v145/*: any*/)
      ],
      "type": "JiraForgeDatetimeField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v140/*: any*/),
        (v145/*: any*/)
      ],
      "type": "JiraForgeDateField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v146/*: any*/),
        (v145/*: any*/)
      ],
      "type": "JiraForgeNumberField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v91/*: any*/),
        (v145/*: any*/)
      ],
      "type": "JiraForgeStringField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v145/*: any*/),
        {
          "args": (v136/*: any*/),
          "concreteType": "JiraLabelConnection",
          "kind": "LinkedField",
          "name": "selectedLabelsConnection",
          "plural": false,
          "selections": [
            (v63/*: any*/),
            (v148/*: any*/)
          ],
          "storageKey": "selectedLabelsConnection(first:1000)"
        }
      ],
      "type": "JiraForgeStringsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v145/*: any*/),
        {
          "concreteType": "JiraGroup",
          "kind": "LinkedField",
          "name": "selectedGroup",
          "plural": false,
          "selections": (v89/*: any*/)
        }
      ],
      "type": "JiraForgeGroupField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v145/*: any*/),
        {
          "concreteType": "JiraGroupConnection",
          "kind": "LinkedField",
          "name": "selectedGroupsConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraGroupEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraGroup",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v149/*: any*/),
                    (v78/*: any*/),
                    (v45/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraForgeGroupsField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v145/*: any*/),
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v150/*: any*/)
        }
      ],
      "type": "JiraForgeUserField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v145/*: any*/),
        {
          "concreteType": "JiraUserConnection",
          "kind": "LinkedField",
          "name": "selectedUsersConnection",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraUserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v150/*: any*/)
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraForgeUsersField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v145/*: any*/)
      ],
      "type": "JiraForgeObjectField"
    }
  ]
},
v152 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "start"
        },
        {
          "kind": "ScalarField",
          "name": "end"
        }
      ],
      "type": "JiraDateRangeField"
    }
  ]
},
v153 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v154 = {
  "kind": "ScalarField",
  "name": "statusId"
},
v155 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v78/*: any*/),
        (v154/*: any*/),
        (v98/*: any*/),
        (v45/*: any*/)
      ]
    },
    (v59/*: any*/)
  ],
  "type": "JiraStatusField"
},
v156 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategoryProgressConnection",
      "kind": "LinkedField",
      "name": "aggregatedStatusCategory",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraStatusCategoryProgressEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraStatusCategoryProgress",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraStatusCategory",
                  "kind": "LinkedField",
                  "name": "statusCategory",
                  "plural": false,
                  "selections": [
                    (v87/*: any*/),
                    (v45/*: any*/)
                  ]
                },
                (v68/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAggregatedStatusField"
},
v157 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": (v76/*: any*/)
},
v158 = [
  (v78/*: any*/),
  (v157/*: any*/)
],
v159 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v136/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v158/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v78/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v160 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v161 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v162 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v163 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v87/*: any*/),
        {
          "concreteType": "JiraColorField",
          "kind": "LinkedField",
          "name": "issueColorField",
          "plural": false,
          "selections": [
            (v157/*: any*/),
            (v45/*: any*/)
          ]
        },
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v160/*: any*/),
                (v78/*: any*/),
                (v45/*: any*/),
                (v161/*: any*/),
                (v114/*: any*/)
              ]
            },
            (v45/*: any*/),
            (v54/*: any*/)
          ]
        },
        {
          "concreteType": "JiraSingleLineTextField",
          "kind": "LinkedField",
          "name": "summaryField",
          "plural": false,
          "selections": [
            (v91/*: any*/),
            (v45/*: any*/),
            (v54/*: any*/)
          ]
        },
        (v45/*: any*/),
        (v113/*: any*/),
        (v162/*: any*/),
        {
          "concreteType": "JiraStatusField",
          "kind": "LinkedField",
          "name": "statusField",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v54/*: any*/),
            (v117/*: any*/)
          ]
        }
      ]
    },
    (v78/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraParentIssueField"
},
v164 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v165 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v78/*: any*/),
        (v164/*: any*/),
        (v45/*: any*/)
      ]
    },
    (v78/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v166 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v78/*: any*/),
        (v87/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v167 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": (v89/*: any*/)
    }
  ],
  "type": "JiraResolutionField"
},
v168 = {
  "kind": "ScalarField",
  "name": "sprintId"
},
v169 = {
  "kind": "ScalarField",
  "name": "state"
},
v170 = [
  (v45/*: any*/),
  (v168/*: any*/),
  (v78/*: any*/),
  (v169/*: any*/),
  {
    "kind": "ScalarField",
    "name": "endDate"
  }
],
v171 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v170/*: any*/)
            }
          ]
        }
      ]
    },
    (v78/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraSprintField"
},
v172 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v173 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v95/*: any*/)
},
v174 = [
  {
    "concreteType": "JiraAdfToConvertedPlainText",
    "kind": "LinkedField",
    "name": "convertedPlainText",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "plainText"
      }
    ]
  }
],
v175 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v174/*: any*/)
        },
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "concreteType": "JiraADF",
              "kind": "LinkedField",
              "name": "adfValue",
              "plural": false,
              "selections": (v174/*: any*/)
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v176 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v78/*: any*/),
        (v160/*: any*/),
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v177 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementOrganizationConnection",
      "kind": "LinkedField",
      "name": "selectedOrganizationsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraServiceManagementOrganizationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraServiceManagementOrganization",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "organizationName"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementOrganizationField"
},
v178 = {
  "kind": "Literal",
  "name": "first",
  "value": 50
},
v179 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        (v178/*: any*/)
      ],
      "concreteType": "JiraAgentSessionConnection",
      "kind": "LinkedField",
      "name": "agentSessions",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        {
          "concreteType": "JiraAgentSessionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAgentSession",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                (v169/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "agent",
                  "plural": false,
                  "selections": [
                    (v41/*: any*/),
                    (v78/*: any*/),
                    (v93/*: any*/),
                    (v92/*: any*/),
                    (v94/*: any*/),
                    (v45/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "agentSessions(first:50)"
    }
  ],
  "type": "JiraAgentSessionsField"
},
v180 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v63/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v162/*: any*/),
                    (v87/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v41/*: any*/),
                                (v99/*: any*/),
                                (v45/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    {
                      "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        (v88/*: any*/)
                      ]
                    },
                    (v45/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v45/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v181 = {
  "kind": "ScalarField",
  "name": "formatStyle"
},
v182 = {
  "kind": "ScalarField",
  "name": "formatUnit"
},
v183 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v146/*: any*/),
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        (v181/*: any*/),
        (v182/*: any*/)
      ]
    },
    (v78/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraNumberField"
},
v184 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCommentSummary",
      "kind": "LinkedField",
      "name": "commentSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canAddComment"
        },
        (v63/*: any*/)
      ]
    }
  ],
  "type": "JiraCommentSummaryField"
},
v185 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "kind": "ScalarField",
      "name": "uri"
    },
    (v131/*: any*/)
  ],
  "type": "JiraUrlField"
},
v186 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v187 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": [
        (v68/*: any*/),
        (v157/*: any*/),
        (v45/*: any*/),
        (v186/*: any*/)
      ]
    },
    (v131/*: any*/)
  ],
  "type": "JiraSingleSelectField"
},
v188 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                (v68/*: any*/),
                (v186/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v131/*: any*/)
  ],
  "type": "JiraMultipleSelectField"
},
v189 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v68/*: any*/)
  ]
},
v190 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            (v189/*: any*/)
          ]
        }
      ]
    },
    (v131/*: any*/)
  ],
  "type": "JiraCheckboxesField"
},
v191 = {
  "concreteType": "JiraUserConnection",
  "kind": "LinkedField",
  "name": "selectedUsersConnection",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraUserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v121/*: any*/),
            (v78/*: any*/),
            (v92/*: any*/),
            (v45/*: any*/),
            (v172/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ]
},
v192 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    (v191/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraMultipleSelectUserPickerField"
},
v193 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "concreteType": "JiraTeamView",
      "kind": "LinkedField",
      "name": "selectedTeam",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedId"
        },
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedName"
        }
      ]
    },
    (v131/*: any*/)
  ],
  "type": "JiraTeamViewField"
},
v194 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTimeTrackingField",
          "kind": "LinkedField",
          "name": "timeTrackingField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraEstimate",
              "kind": "LinkedField",
              "name": "originalEstimate",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "timeInSeconds"
                }
              ]
            },
            {
              "concreteType": "JiraTimeTrackingSettings",
              "kind": "LinkedField",
              "name": "timeTrackingSettings",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "workingHoursPerDay"
                },
                {
                  "kind": "ScalarField",
                  "name": "workingDaysPerWeek"
                },
                {
                  "kind": "ScalarField",
                  "name": "defaultFormat"
                },
                {
                  "kind": "ScalarField",
                  "name": "defaultUnit"
                }
              ]
            },
            (v45/*: any*/),
            (v54/*: any*/),
            (v78/*: any*/),
            (v64/*: any*/)
          ]
        },
        (v45/*: any*/)
      ]
    },
    (v131/*: any*/)
  ],
  "type": "JiraOriginalTimeEstimateField"
},
v195 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "value"
},
v196 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "selectedOption",
      "plural": false,
      "selections": [
        (v195/*: any*/),
        (v45/*: any*/),
        (v137/*: any*/)
      ]
    },
    (v131/*: any*/)
  ],
  "type": "JiraRadioSelectField"
},
v197 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v198 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "args": (v136/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                (v78/*: any*/),
                (v137/*: any*/),
                (v138/*: any*/),
                (v197/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    },
    (v131/*: any*/)
  ],
  "type": "JiraMultipleVersionPickerField"
},
v199 = [
  (v45/*: any*/)
],
v200 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v199/*: any*/)
},
v201 = {
  "kind": "ScalarField",
  "name": "status"
},
v202 = [
  {
    "kind": "ScalarField",
    "name": "isPrivate"
  }
],
v203 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    (v200/*: any*/),
    {
      "args": (v136/*: any*/),
      "concreteType": "JiraGoalConnection",
      "kind": "LinkedField",
      "name": "selectedGoals",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGoalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                (v87/*: any*/),
                (v78/*: any*/),
                (v201/*: any*/),
                {
                  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": (v202/*: any*/)
                }
              ]
            }
          ]
        },
        (v59/*: any*/)
      ],
      "storageKey": "selectedGoals(first:1000)"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        (v58/*: any*/),
        (v130/*: any*/)
      ]
    }
  ],
  "type": "JiraGoalsField"
},
v204 = {
  "kind": "ScalarField",
  "name": "privateProject"
},
v205 = {
  "kind": "ScalarField",
  "name": "hasPermission"
},
v206 = {
  "kind": "ScalarField",
  "name": "isWorkspaceActive"
},
v207 = {
  "kind": "ScalarField",
  "name": "iconName"
},
v208 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v78/*: any*/),
        (v200/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isLinkEditable"
        },
        {
          "concreteType": "JiraTownsquareProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            {
              "alias": "atlasProjectName",
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "alias": "atlasProjectKey",
              "kind": "ScalarField",
              "name": "key"
            },
            (v204/*: any*/),
            (v205/*: any*/),
            (v206/*: any*/),
            (v207/*: any*/)
          ]
        },
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isLinkInherited"
            },
            {
              "kind": "ScalarField",
              "name": "isParentLinked"
            }
          ]
        },
        (v131/*: any*/)
      ],
      "type": "JiraTownsquareProjectField"
    }
  ]
},
v209 = {
  "kind": "ScalarField",
  "name": "href"
},
v210 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "args": (v136/*: any*/),
      "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
      "kind": "LinkedField",
      "name": "confluenceRemoteIssueLinks",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                (v209/*: any*/),
                {
                  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "pageContent",
                      "plural": false,
                      "selections": [
                        (v41/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v209/*: any*/)
                          ],
                          "type": "JiraConfluencePageContentDetails"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v63/*: any*/)
      ],
      "storageKey": "confluenceRemoteIssueLinks(first:1000)"
    },
    (v131/*: any*/)
  ],
  "type": "JiraConfluenceRemoteIssueLinksField"
},
v211 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "concreteType": "JiraGroupConnection",
      "kind": "LinkedField",
      "name": "selectedGroupsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                (v78/*: any*/),
                (v149/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v131/*: any*/)
  ],
  "type": "JiraMultipleGroupPickerField"
},
v212 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraFlag",
      "kind": "LinkedField",
      "name": "flag",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFlagged"
        }
      ]
    }
  ],
  "type": "JiraFlagField"
},
v213 = {
  "kind": "ScalarField",
  "name": "count"
},
v214 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraWatch",
      "kind": "LinkedField",
      "name": "watch",
      "plural": false,
      "selections": [
        (v213/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isWatching"
        }
      ]
    }
  ],
  "type": "JiraWatchesField"
},
v215 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v78/*: any*/),
        (v146/*: any*/),
        {
          "concreteType": "JiraNumberFieldFormatConfig",
          "kind": "LinkedField",
          "name": "formatConfig",
          "plural": false,
          "selections": [
            (v181/*: any*/),
            (v182/*: any*/),
            {
              "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "durationUnits"
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraNumberFormulaField"
    }
  ]
},
v216 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v78/*: any*/),
        (v91/*: any*/)
      ],
      "type": "JiraTextFormulaField"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v143/*: any*/),
        (v78/*: any*/)
      ],
      "type": "JiraDateFormulaField"
    }
  ]
},
v217 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v78/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isMulti"
        },
        (v191/*: any*/),
        (v131/*: any*/)
      ],
      "type": "JiraPeopleField"
    }
  ]
},
v218 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v157/*: any*/)
      ],
      "type": "JiraColorField"
    }
  ]
},
v219 = [
  (v213/*: any*/)
],
v220 = {
  "kind": "ScalarField",
  "name": "stateCount"
},
v221 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueDevSummary",
      "kind": "LinkedField",
      "name": "devSummary",
      "plural": false,
      "selections": [
        (v41/*: any*/),
        {
          "concreteType": "JiraIssueBranchDevSummaryContainer",
          "kind": "LinkedField",
          "name": "branch",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueBranchDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": (v219/*: any*/)
            }
          ]
        },
        {
          "concreteType": "JiraIssueCommitDevSummaryContainer",
          "kind": "LinkedField",
          "name": "commit",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueCommitDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": (v219/*: any*/)
            }
          ]
        },
        {
          "concreteType": "JiraIssuePullRequestDevSummaryContainer",
          "kind": "LinkedField",
          "name": "pullrequest",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssuePullRequestDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v220/*: any*/),
                (v169/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "open"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueReviewDevSummaryContainer",
          "kind": "LinkedField",
          "name": "review",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueReviewDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v220/*: any*/),
                (v169/*: any*/)
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueBuildDevSummaryContainer",
          "kind": "LinkedField",
          "name": "build",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueBuildDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": [
                (v213/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "failedBuildCount"
                },
                {
                  "kind": "ScalarField",
                  "name": "successfulBuildCount"
                },
                {
                  "kind": "ScalarField",
                  "name": "unknownBuildCount"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
          "kind": "LinkedField",
          "name": "deploymentEnvironments",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
              "kind": "LinkedField",
              "name": "overall",
              "plural": false,
              "selections": (v219/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        (v113/*: any*/),
        (v87/*: any*/),
        {
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": (v199/*: any*/)
        },
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraDevSummaryField"
},
v222 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "durationInSeconds"
    },
    (v91/*: any*/)
  ],
  "type": "JiraDurationField"
},
v223 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementFeedback",
      "kind": "LinkedField",
      "name": "feedback",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "rating"
        }
      ]
    }
  ],
  "type": "JiraServiceManagementRequestFeedbackField"
},
v224 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementSla",
      "kind": "LinkedField",
      "name": "sla",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraServiceManagementSlaError",
          "kind": "LinkedField",
          "name": "error",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "errorCode"
            },
            {
              "kind": "ScalarField",
              "name": "goalId"
            },
            {
              "kind": "ScalarField",
              "name": "timeMetricId"
            }
          ]
        },
        {
          "concreteType": "JiraServiceManagementSlaGoalView",
          "kind": "LinkedField",
          "name": "goalView",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "paused"
            },
            {
              "kind": "ScalarField",
              "name": "active"
            },
            {
              "kind": "ScalarField",
              "name": "closed"
            },
            {
              "kind": "ScalarField",
              "name": "failed"
            },
            {
              "kind": "ScalarField",
              "name": "emergencyLevel"
            },
            {
              "kind": "ScalarField",
              "name": "remainingTime"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementSlaField"
},
v225 = [
  (v91/*: any*/)
],
v226 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v225/*: any*/),
          "type": "JiraRemoteSingleLineTextField"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "avatarUrl"
            },
            {
              "kind": "ScalarField",
              "name": "issueTypeName"
            }
          ],
          "type": "JiraRemoteIssueTypeField"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "priorityName"
            },
            {
              "kind": "ScalarField",
              "name": "priorityIconUrl"
            }
          ],
          "type": "JiraRemotePriorityField"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "userDisplayName"
            },
            {
              "kind": "ScalarField",
              "name": "avatarSmall"
            }
          ],
          "type": "JiraRemoteSingleSelectUserPickerField"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v154/*: any*/),
            {
              "kind": "ScalarField",
              "name": "statusName"
            },
            (v97/*: any*/)
          ],
          "type": "JiraRemoteStatusField"
        },
        {
          "kind": "InlineFragment",
          "selections": (v147/*: any*/),
          "type": "JiraRemoteGenericField"
        }
      ],
      "type": "JiraRemoteIssueField",
      "abstractKey": "__isJiraRemoteIssueField"
    }
  ]
},
v227 = {
  "kind": "InlineFragment",
  "selections": [
    (v143/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v228 = {
  "kind": "InlineFragment",
  "selections": [
    (v91/*: any*/),
    (v78/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v229 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v78/*: any*/),
        (v97/*: any*/),
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v230 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v96/*: any*/),
        (v78/*: any*/),
        (v45/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v231 = {
  "kind": "InlineFragment",
  "selections": [
    (v78/*: any*/),
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v41/*: any*/),
        (v78/*: any*/),
        (v92/*: any*/),
        (v172/*: any*/),
        (v45/*: any*/),
        (v121/*: any*/),
        (v173/*: any*/),
        (v94/*: any*/)
      ]
    },
    (v141/*: any*/),
    (v131/*: any*/)
  ],
  "type": "JiraSingleSelectUserPickerField"
},
v232 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v78/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v132/*: any*/),
            (v179/*: any*/),
            (v134/*: any*/),
            (v135/*: any*/),
            (v139/*: any*/),
            (v142/*: any*/),
            (v227/*: any*/),
            (v142/*: any*/),
            (v151/*: any*/),
            (v144/*: any*/),
            (v216/*: any*/),
            (v152/*: any*/),
            (v153/*: any*/),
            (v228/*: any*/),
            (v229/*: any*/),
            (v155/*: any*/),
            (v156/*: any*/),
            (v159/*: any*/),
            (v230/*: any*/),
            (v163/*: any*/),
            (v165/*: any*/),
            (v166/*: any*/),
            (v167/*: any*/),
            (v171/*: any*/),
            (v231/*: any*/),
            (v175/*: any*/),
            (v176/*: any*/),
            (v177/*: any*/),
            (v180/*: any*/),
            (v183/*: any*/),
            (v184/*: any*/),
            (v185/*: any*/),
            (v187/*: any*/),
            (v188/*: any*/),
            (v190/*: any*/),
            (v192/*: any*/),
            (v193/*: any*/),
            (v194/*: any*/),
            (v196/*: any*/),
            (v198/*: any*/),
            (v203/*: any*/),
            (v208/*: any*/),
            (v210/*: any*/),
            (v211/*: any*/),
            (v212/*: any*/),
            (v214/*: any*/),
            (v215/*: any*/),
            (v217/*: any*/),
            (v218/*: any*/),
            (v221/*: any*/),
            (v222/*: any*/),
            (v223/*: any*/),
            (v224/*: any*/)
          ],
          "type": "JiraIssueField",
          "abstractKey": "__isJiraIssueField"
        }
      ]
    }
  ]
},
v233 = [
  (v140/*: any*/)
],
v234 = [
  (v146/*: any*/)
],
v235 = {
  "kind": "ScalarField",
  "name": "priorityId"
},
v236 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v237 = [
  (v197/*: any*/),
  (v45/*: any*/)
],
v238 = [
  (v41/*: any*/),
  (v45/*: any*/)
],
v239 = {
  "args": (v90/*: any*/),
  "kind": "LinkedField",
  "name": "fieldSets",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v128/*: any*/),
    {
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v41/*: any*/),
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v64/*: any*/),
            (v49/*: any*/),
            (v129/*: any*/),
            {
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                (v41/*: any*/),
                {
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v41/*: any*/),
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v131/*: any*/)
                              ],
                              "type": "JiraSingleLineTextField"
                            }
                          ],
                          "type": "JiraIssueField",
                          "abstractKey": "__isJiraIssueField"
                        },
                        {
                          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                          "kind": "Condition",
                          "passingValue": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v132/*: any*/),
                                (v134/*: any*/),
                                (v135/*: any*/),
                                (v139/*: any*/),
                                (v142/*: any*/),
                                (v144/*: any*/),
                                (v151/*: any*/),
                                (v152/*: any*/),
                                (v153/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "concreteType": "JiraStatusCategory",
                                      "kind": "LinkedField",
                                      "name": "statusCategory",
                                      "plural": false,
                                      "selections": (v147/*: any*/)
                                    }
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v155/*: any*/),
                                (v156/*: any*/),
                                (v159/*: any*/),
                                (v163/*: any*/),
                                (v165/*: any*/),
                                (v166/*: any*/),
                                (v167/*: any*/),
                                (v171/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "name": "user",
                                      "plural": false,
                                      "selections": [
                                        (v172/*: any*/),
                                        (v121/*: any*/),
                                        (v173/*: any*/),
                                        (v94/*: any*/)
                                      ]
                                    },
                                    (v141/*: any*/),
                                    (v131/*: any*/)
                                  ],
                                  "type": "JiraSingleSelectUserPickerField"
                                },
                                (v175/*: any*/),
                                (v176/*: any*/),
                                (v177/*: any*/),
                                (v179/*: any*/),
                                (v180/*: any*/),
                                (v183/*: any*/),
                                (v184/*: any*/),
                                (v185/*: any*/),
                                (v187/*: any*/),
                                (v188/*: any*/),
                                (v190/*: any*/),
                                (v192/*: any*/),
                                (v193/*: any*/),
                                (v194/*: any*/),
                                (v196/*: any*/),
                                (v198/*: any*/),
                                (v203/*: any*/),
                                (v208/*: any*/),
                                (v210/*: any*/),
                                (v211/*: any*/),
                                (v212/*: any*/),
                                (v214/*: any*/),
                                (v215/*: any*/),
                                (v216/*: any*/),
                                (v217/*: any*/),
                                (v218/*: any*/),
                                (v221/*: any*/),
                                (v222/*: any*/),
                                (v223/*: any*/),
                                (v224/*: any*/)
                              ],
                              "type": "JiraIssueField",
                              "abstractKey": "__isJiraIssueField"
                            }
                          ]
                        },
                        (v226/*: any*/),
                        (v59/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraOptionConnection",
                              "kind": "LinkedField",
                              "name": "selectedOptions",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraOptionEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    (v189/*: any*/),
                                    (v59/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ],
                          "type": "JiraCheckboxesField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraOption",
                              "kind": "LinkedField",
                              "name": "fieldOption",
                              "plural": false,
                              "selections": [
                                (v186/*: any*/),
                                (v45/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraSingleSelectField"
                        }
                      ]
                    },
                    (v232/*: any*/)
                  ]
                },
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isJiraListRowFieldConnection"
                }
              ]
            },
            (v59/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "shouldQueryConditionalFormatting",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "args": (v136/*: any*/),
                                  "concreteType": "JiraComponentConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedComponentsConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraComponentEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "concreteType": "JiraComponent",
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "ScalarField",
                                              "name": "componentId"
                                            },
                                            (v45/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ],
                                  "storageKey": "selectedComponentsConnection(first:1000)"
                                }
                              ],
                              "type": "JiraComponentsField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "args": (v136/*: any*/),
                                  "concreteType": "JiraLabelConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedLabelsConnection",
                                  "plural": false,
                                  "selections": [
                                    (v148/*: any*/)
                                  ],
                                  "storageKey": "selectedLabelsConnection(first:1000)"
                                }
                              ],
                              "type": "JiraLabelsField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "user",
                                  "plural": false,
                                  "selections": [
                                    (v121/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraSingleSelectUserPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraUserConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedUsersConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraUserEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            (v41/*: any*/),
                                            (v121/*: any*/),
                                            (v45/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraMultipleSelectUserPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v233/*: any*/),
                              "type": "JiraDatePickerField"
                            },
                            (v227/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": (v234/*: any*/),
                              "type": "JiraNumberField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraPriority",
                                  "kind": "LinkedField",
                                  "name": "priority",
                                  "plural": false,
                                  "selections": [
                                    (v235/*: any*/),
                                    (v45/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraPriorityField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraProject",
                                  "kind": "LinkedField",
                                  "name": "project",
                                  "plural": false,
                                  "selections": [
                                    (v236/*: any*/),
                                    (v45/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraProjectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraSprintConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedSprintsConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraSprintEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "concreteType": "JiraSprint",
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            (v168/*: any*/),
                                            (v45/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraSprintField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraVersion",
                                  "kind": "LinkedField",
                                  "name": "version",
                                  "plural": false,
                                  "selections": (v237/*: any*/)
                                }
                              ],
                              "type": "JiraSingleVersionPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraIssueType",
                                  "kind": "LinkedField",
                                  "name": "issueType",
                                  "plural": false,
                                  "selections": [
                                    (v161/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraIssueTypeField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraStatus",
                                  "kind": "LinkedField",
                                  "name": "status",
                                  "plural": false,
                                  "selections": [
                                    (v154/*: any*/),
                                    (v45/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraStatusField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "args": (v136/*: any*/),
                                  "concreteType": "JiraVersionConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedVersionsConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraVersionEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "concreteType": "JiraVersion",
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": (v237/*: any*/)
                                        }
                                      ]
                                    }
                                  ],
                                  "storageKey": "selectedVersionsConnection(first:1000)"
                                }
                              ],
                              "type": "JiraMultipleVersionPickerField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "selectedValue",
                                  "plural": false,
                                  "selections": (v238/*: any*/)
                                }
                              ],
                              "type": "JiraSingleSelectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraSelectableValueConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedValues",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraSelectableValueEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": (v238/*: any*/)
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraMultipleSelectField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraOption",
                                  "kind": "LinkedField",
                                  "name": "selectedOption",
                                  "plural": false,
                                  "selections": [
                                    (v195/*: any*/),
                                    (v45/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraRadioSelectField"
                            },
                            {
                              "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider",
                              "kind": "Condition",
                              "passingValue": true,
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v234/*: any*/),
                                  "type": "JiraNumberFormulaField"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v225/*: any*/),
                                  "type": "JiraTextFormulaField"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v233/*: any*/),
                                  "type": "JiraDateFormulaField"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "fieldSets(first:500)"
},
v240 = {
  "concreteType": "JiraIssueNavigatorPageInfo",
  "kind": "LinkedField",
  "name": "issueNavigatorPageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastIssuePosition"
    }
  ]
},
v241 = {
  "kind": "ScalarField",
  "name": "isCurrent"
},
v242 = [
  (v86/*: any*/),
  (v241/*: any*/)
],
v243 = {
  "args": (v105/*: any*/),
  "concreteType": "JiraPageCursors",
  "kind": "LinkedField",
  "name": "pageCursors",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "first",
      "plural": false,
      "selections": [
        (v86/*: any*/),
        (v106/*: any*/),
        (v241/*: any*/)
      ]
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "around",
      "plural": true,
      "selections": (v242/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "last",
      "plural": false,
      "selections": (v242/*: any*/)
    }
  ],
  "storageKey": "pageCursors(maxCursors:7)"
},
v244 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v119/*: any*/)
          ]
        }
      ]
    }
  ]
},
v245 = [
  {
    "concreteType": "JiraIssueSearchWarning",
    "kind": "LinkedField",
    "name": "searchWarnings",
    "plural": true,
    "selections": (v110/*: any*/)
  }
],
v246 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v245/*: any*/)
},
v247 = [
  "scope"
],
v248 = {
  "kind": "Variable",
  "name": "__dynamicKey",
  "variableName": "dynamicSearchKey"
},
v249 = [
  {
    "kind": "ScalarField",
    "name": "defaultJql"
  }
],
v250 = [
  (v79/*: any*/),
  (v80/*: any*/),
  (v82/*: any*/),
  (v52/*: any*/),
  (v37/*: any*/),
  (v83/*: any*/),
  (v60/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/)
],
v251 = {
  "kind": "ScalarField",
  "name": "issueCount"
},
v252 = {
  "kind": "ScalarField",
  "name": "fieldType"
},
v253 = {
  "kind": "LinkedField",
  "name": "fieldValue",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v66/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraPriority",
          "kind": "LinkedField",
          "name": "priority",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v235/*: any*/),
            (v78/*: any*/),
            (v164/*: any*/)
          ]
        },
        (v65/*: any*/)
      ],
      "type": "JiraJqlPriorityFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v41/*: any*/),
            (v45/*: any*/),
            (v121/*: any*/),
            (v78/*: any*/),
            (v92/*: any*/),
            {
              "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v95/*: any*/)
            }
          ]
        },
        (v65/*: any*/)
      ],
      "type": "JiraJqlUserFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v78/*: any*/),
            {
              "concreteType": "JiraStatusCategory",
              "kind": "LinkedField",
              "name": "statusCategory",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                (v97/*: any*/)
              ]
            }
          ]
        },
        (v65/*: any*/),
        (v98/*: any*/)
      ],
      "type": "JiraJqlStatusFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": (v234/*: any*/),
      "type": "JiraJqlNumberFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "option",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v186/*: any*/),
            (v68/*: any*/),
            (v157/*: any*/)
          ]
        },
        (v65/*: any*/)
      ],
      "type": "JiraJqlOptionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraSprint",
          "kind": "LinkedField",
          "name": "sprint",
          "plural": false,
          "selections": (v170/*: any*/)
        },
        (v65/*: any*/)
      ],
      "type": "JiraJqlSprintFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraLabel",
          "kind": "LinkedField",
          "name": "label",
          "plural": false,
          "selections": (v158/*: any*/)
        }
      ],
      "type": "JiraJqlLabelFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraGroup",
          "kind": "LinkedField",
          "name": "group",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v149/*: any*/),
            (v78/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlGroupFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraVersion",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v197/*: any*/),
            (v78/*: any*/)
          ]
        },
        (v65/*: any*/)
      ],
      "type": "JiraJqlVersionFieldValue"
    },
    {
      "condition": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraTownsquareProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v45/*: any*/),
                (v87/*: any*/),
                (v78/*: any*/),
                (v204/*: any*/),
                (v205/*: any*/),
                (v207/*: any*/),
                (v206/*: any*/)
              ]
            }
          ],
          "type": "JiraJqlTownsquareProjectFieldValue"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v65/*: any*/),
        {
          "kind": "ScalarField",
          "name": "rangeStart"
        },
        {
          "kind": "ScalarField",
          "name": "rangeEnd"
        }
      ],
      "type": "JiraJqlDateBucketFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v65/*: any*/),
        {
          "concreteType": "JiraGoal",
          "kind": "LinkedField",
          "name": "goal",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v87/*: any*/),
            (v78/*: any*/),
            (v201/*: any*/),
            {
              "kind": "ScalarField",
              "name": "score"
            },
            {
              "condition": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider",
              "kind": "Condition",
              "passingValue": true,
              "selections": (v202/*: any*/)
            }
          ]
        }
      ],
      "type": "JiraJqlGoalsFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraTownsquareProject",
          "kind": "LinkedField",
          "name": "project",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v87/*: any*/),
            (v204/*: any*/),
            (v205/*: any*/),
            (v78/*: any*/),
            (v207/*: any*/),
            (v169/*: any*/),
            (v206/*: any*/),
            {
              "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "dueDate"
                },
                {
                  "kind": "LinkedField",
                  "name": "owner",
                  "plural": false,
                  "selections": [
                    (v41/*: any*/),
                    (v78/*: any*/),
                    (v92/*: any*/),
                    (v45/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraJqlTownsquareProjectFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssueType",
          "kind": "LinkedField",
          "name": "issueTypes",
          "plural": true,
          "selections": [
            (v78/*: any*/),
            (v96/*: any*/),
            (v45/*: any*/),
            (v161/*: any*/),
            (v114/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlIssueTypeFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v65/*: any*/),
        {
          "concreteType": "JiraResolution",
          "kind": "LinkedField",
          "name": "resolution",
          "plural": false,
          "selections": [
            (v45/*: any*/),
            (v78/*: any*/)
          ]
        }
      ],
      "type": "JiraJqlResolutionFieldValue"
    }
  ]
},
v254 = {
  "kind": "Variable",
  "name": "viewConfigInput",
  "variableName": "viewConfigInput"
},
v255 = [
  (v81/*: any*/),
  (v178/*: any*/),
  (v37/*: any*/),
  (v47/*: any*/),
  (v40/*: any*/),
  (v254/*: any*/)
],
v256 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "filterByProjectKeys.0",
        "variableName": "projectKey"
      }
    ],
    "kind": "ListValue",
    "name": "filterByProjectKeys"
  }
],
v257 = [
  (v33/*: any*/)
],
v258 = {
  "condition": "shouldQueryHasChildren",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": (v256/*: any*/),
      "kind": "ScalarField",
      "name": "hasChildren"
    },
    {
      "alias": "canHaveChildIssuesWithOldCondition",
      "args": (v257/*: any*/),
      "kind": "ScalarField",
      "name": "canHaveChildIssues"
    }
  ]
},
v259 = {
  "condition": "shouldQueryHasChildrenWithCount",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": (v256/*: any*/),
      "concreteType": "JiraIssueEdgeChildIssuesInfo",
      "kind": "LinkedField",
      "name": "childIssuesInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "childrenCount"
        }
      ]
    },
    {
      "args": (v257/*: any*/),
      "kind": "ScalarField",
      "name": "canHaveChildIssues"
    }
  ]
},
v260 = [
  (v79/*: any*/),
  (v80/*: any*/),
  (v81/*: any*/),
  (v82/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/),
  (v83/*: any*/),
  (v84/*: any*/),
  (v60/*: any*/),
  (v39/*: any*/),
  (v40/*: any*/),
  (v254/*: any*/)
],
v261 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "feature",
        "variableName": "atlassianIntelligenceProductFeature"
      }
    ],
    "kind": "ObjectValue",
    "name": "atlassianIntelligenceProductFeatureInput"
  },
  (v34/*: any*/)
],
v262 = [
  (v34/*: any*/)
],
v263 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_IssueNavigatorQuery",
    "selections": [
      {
        "args": [
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          {
            "items": [
              {
                "kind": "Variable",
                "name": "projectKeys.0",
                "variableName": "projectKey"
              }
            ],
            "kind": "ListValue",
            "name": "projectKeys"
          },
          {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
          },
          {
            "kind": "Variable",
            "name": "shouldQueryHasChildrenWithCount",
            "variableName": "shouldQueryHasChildrenWithCount"
          }
        ],
        "kind": "FragmentSpread",
        "name": "main_IssueNavigatorIssueNavigator_IssueNavigator_issueQuery"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "shouldQueryRankField",
                "variableName": "shouldQueryRankField"
              }
            ],
            "kind": "FragmentSpread",
            "name": "main_IssueNavigatorIssueNavigator_IssueNavigator_jira"
          },
          {
            "condition": "shouldQueryProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v35/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      (v31/*: any*/),
                      (v32/*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "IssueNavigatorUIComponent_project_jiraProject"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "IssueSearch_issueNavigatorProject"
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "shouldQueryConditionalFormatting",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v36/*: any*/),
                            "kind": "FragmentSpread",
                            "name": "ConditionalFormattingInner"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "ConditionalFormattingSidebarContainer_project"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v12/*: any*/),
      (v9/*: any*/),
      (v14/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v15/*: any*/),
      (v30/*: any*/),
      (v16/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v17/*: any*/),
      (v25/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v27/*: any*/),
      (v11/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v19/*: any*/),
      (v10/*: any*/),
      (v26/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v7/*: any*/),
      (v13/*: any*/),
      (v20/*: any*/),
      (v18/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsJSCExpandAllChangesEnabledRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider"
      }
    ],
    "kind": "Operation",
    "name": "main_IssueNavigatorQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v34/*: any*/),
              {
                "kind": "Variable",
                "name": "filterId",
                "variableName": "filterId"
              },
              (v37/*: any*/),
              (v38/*: any*/),
              {
                "kind": "Variable",
                "name": "namespace",
                "variableName": "namespace"
              },
              (v39/*: any*/),
              (v40/*: any*/),
              {
                "kind": "Variable",
                "name": "viewConfigInput",
                "variableName": "staticViewInput"
              },
              {
                "kind": "Variable",
                "name": "viewId",
                "variableName": "viewId"
              }
            ],
            "kind": "LinkedField",
            "name": "jiraIssueSearchView",
            "plural": false,
            "selections": [
              (v41/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraView"
              },
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": (v44/*: any*/)
              },
              (v45/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v46/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "viewId"
                  },
                  {
                    "args": (v48/*: any*/),
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v49/*: any*/),
                              {
                                "concreteType": "JiraFieldSetPreferences",
                                "kind": "LinkedField",
                                "name": "fieldSetPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isFrozen"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldQuerySaveResetViewSettingsButton",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canPublishViewConfig"
                      },
                      (v50/*: any*/),
                      (v51/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v53/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      },
                      (v59/*: any*/)
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          (v37/*: any*/),
                          (v60/*: any*/),
                          (v39/*: any*/)
                        ],
                        "concreteType": "JiraJqlValidationResult",
                        "kind": "LinkedField",
                        "name": "validateJql",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                              (v43/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "extensions",
                                "plural": true,
                                "selections": [
                                  (v41/*: any*/),
                                  (v61/*: any*/),
                                  (v42/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v50/*: any*/)
                    ]
                  }
                ],
                "type": "JiraIssueSearchViewMetadata",
                "abstractKey": "__isJiraIssueSearchViewMetadata"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v53/*: any*/),
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isGroupingEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canEnableGrouping"
                      },
                      (v55/*: any*/),
                      (v57/*: any*/),
                      (v56/*: any*/),
                      (v62/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": [
                          (v47/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "hasDefaultFieldSets"
                      },
                      {
                        "args": (v48/*: any*/),
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          (v63/*: any*/),
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "width"
                                      }
                                    ]
                                  },
                                  (v64/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/),
                                  (v67/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                  },
                                  {
                                    "concreteType": "JiraFieldType",
                                    "kind": "LinkedField",
                                    "name": "fieldType",
                                    "plural": false,
                                    "selections": [
                                      (v65/*: any*/)
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldsMetadata",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueSearchMetadataField",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "canBeConfigured"
                                                  },
                                                  (v54/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isPlaceHolderField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v59/*: any*/)
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v51/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v53/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              (v57/*: any*/),
                              (v62/*: any*/),
                              (v56/*: any*/),
                              (v55/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canEnableReranking"
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "args": (v36/*: any*/),
                                "concreteType": "JiraFormattingRuleConnection",
                                "kind": "LinkedField",
                                "name": "conditionalFormattingRules",
                                "plural": false,
                                "selections": [
                                  {
                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v75/*: any*/)
                                  }
                                ],
                                "storageKey": "conditionalFormattingRules(first:20)"
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      },
                      (v59/*: any*/)
                    ],
                    "type": "JiraIssueSearchViewMetadata",
                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v50/*: any*/),
                      {
                        "args": (v36/*: any*/),
                        "concreteType": "JiraFormattingRuleConnection",
                        "kind": "LinkedField",
                        "name": "conditionalFormattingRules",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v45/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "expression",
                                    "plural": false,
                                    "selections": [
                                      (v41/*: any*/),
                                      (v70/*: any*/),
                                      (v69/*: any*/),
                                      (v71/*: any*/)
                                    ]
                                  },
                                  (v77/*: any*/),
                                  (v73/*: any*/)
                                ]
                              },
                              (v41/*: any*/)
                            ]
                          },
                          (v59/*: any*/)
                        ],
                        "storageKey": "conditionalFormattingRules(first:20)"
                      },
                      (v59/*: any*/)
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v46/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "filterId"
                          },
                          {
                            "args": (v53/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewSettings",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraSpreadsheetGroupByConfig",
                                "kind": "LinkedField",
                                "name": "groupByConfig",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                      (v78/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "typeKey"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "JiraSpreadsheetView",
                        "abstractKey": "__isJiraSpreadsheetView"
                      }
                    ],
                    "type": "JiraView",
                    "abstractKey": "__isJiraView"
                  }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v85/*: any*/),
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                      (v100/*: any*/),
                      (v103/*: any*/),
                      (v104/*: any*/),
                      (v108/*: any*/),
                      (v109/*: any*/),
                      (v111/*: any*/),
                      (v112/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v126/*: any*/),
                              (v127/*: any*/),
                              (v239/*: any*/),
                              (v59/*: any*/)
                            ]
                          },
                          (v46/*: any*/),
                          (v240/*: any*/),
                          (v243/*: any*/),
                          (v59/*: any*/)
                        ],
                        "type": "JiraListRowConnection",
                        "abstractKey": "__isJiraListRowConnection"
                      },
                      (v244/*: any*/),
                      (v59/*: any*/),
                      (v246/*: any*/)
                    ]
                  },
                  {
                    "args": (v85/*: any*/),
                    "filters": (v247/*: any*/),
                    "handle": "connection",
                    "key": "IssueNavigatorJiraDetailedViewPagination__issues",
                    "kind": "LinkedHandle",
                    "name": "issues",
                    "dynamicKey": (v248/*: any*/)
                  }
                ],
                "type": "JiraDetailedView"
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": (v249/*: any*/),
                    "type": "JiraDetailedView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v249/*: any*/),
                    "type": "JiraGroupedListView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v249/*: any*/),
                    "type": "JiraListView"
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v250/*: any*/),
                    "concreteType": "JiraSpreadsheetGroupConnection",
                    "kind": "LinkedField",
                    "name": "groups",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSpreadsheetGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v86/*: any*/),
                          {
                            "concreteType": "JiraSpreadsheetGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              (v45/*: any*/),
                              (v251/*: any*/),
                              (v46/*: any*/),
                              (v54/*: any*/),
                              (v252/*: any*/),
                              (v49/*: any*/),
                              (v253/*: any*/)
                            ]
                          },
                          (v41/*: any*/)
                        ]
                      },
                      (v103/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "groupByField"
                      },
                      (v46/*: any*/),
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": (v44/*: any*/)
                      },
                      {
                        "condition": "isPaginating",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "concreteType": "JiraSpreadsheetGroup",
                            "kind": "LinkedField",
                            "name": "firstGroup",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/),
                              {
                                "alias": "issuesWithIssueSearchInput",
                                "args": (v255/*: any*/),
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v41/*: any*/),
                                      (v86/*: any*/),
                                      {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v238/*: any*/)
                                      },
                                      {
                                        "args": (v90/*: any*/),
                                        "concreteType": "JiraIssueFieldSetConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldSets",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueFieldSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v54/*: any*/),
                                                              (v41/*: any*/),
                                                              (v64/*: any*/),
                                                              (v45/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "fieldSets(first:500)"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                      (v101/*: any*/),
                                      (v102/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v109/*: any*/),
                                      (v112/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v113/*: any*/),
                                              (v87/*: any*/),
                                              (v115/*: any*/),
                                              (v116/*: any*/),
                                              (v88/*: any*/),
                                              (v118/*: any*/),
                                              (v119/*: any*/),
                                              (v123/*: any*/),
                                              (v59/*: any*/),
                                              (v124/*: any*/),
                                              (v125/*: any*/)
                                            ]
                                          },
                                          (v127/*: any*/),
                                          {
                                            "args": (v90/*: any*/),
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                              (v41/*: any*/),
                                              (v128/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  (v41/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v41/*: any*/),
                                                      (v64/*: any*/),
                                                      (v49/*: any*/),
                                                      (v129/*: any*/),
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": false,
                                                        "selections": [
                                                          (v41/*: any*/),
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              (v41/*: any*/),
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v228/*: any*/),
                                                                      (v230/*: any*/)
                                                                    ],
                                                                    "type": "JiraIssueField",
                                                                    "abstractKey": "__isJiraIssueField"
                                                                  },
                                                                  {
                                                                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v132/*: any*/),
                                                                          (v134/*: any*/),
                                                                          (v135/*: any*/),
                                                                          (v139/*: any*/),
                                                                          (v142/*: any*/),
                                                                          (v144/*: any*/),
                                                                          (v151/*: any*/),
                                                                          (v152/*: any*/),
                                                                          (v153/*: any*/),
                                                                          (v229/*: any*/),
                                                                          (v155/*: any*/),
                                                                          (v156/*: any*/),
                                                                          (v159/*: any*/),
                                                                          (v163/*: any*/),
                                                                          (v165/*: any*/),
                                                                          (v166/*: any*/),
                                                                          (v167/*: any*/),
                                                                          (v171/*: any*/),
                                                                          (v231/*: any*/),
                                                                          (v175/*: any*/),
                                                                          (v176/*: any*/),
                                                                          (v177/*: any*/),
                                                                          (v179/*: any*/),
                                                                          (v180/*: any*/),
                                                                          (v183/*: any*/),
                                                                          (v184/*: any*/),
                                                                          (v185/*: any*/),
                                                                          (v187/*: any*/),
                                                                          (v188/*: any*/),
                                                                          (v190/*: any*/),
                                                                          (v192/*: any*/),
                                                                          (v193/*: any*/),
                                                                          (v194/*: any*/),
                                                                          (v196/*: any*/),
                                                                          (v198/*: any*/),
                                                                          (v203/*: any*/),
                                                                          (v208/*: any*/),
                                                                          (v210/*: any*/),
                                                                          (v211/*: any*/),
                                                                          (v212/*: any*/),
                                                                          (v214/*: any*/),
                                                                          (v215/*: any*/),
                                                                          (v216/*: any*/),
                                                                          (v217/*: any*/),
                                                                          (v218/*: any*/),
                                                                          (v221/*: any*/),
                                                                          (v222/*: any*/),
                                                                          (v223/*: any*/),
                                                                          (v224/*: any*/)
                                                                        ],
                                                                        "type": "JiraIssueField",
                                                                        "abstractKey": "__isJiraIssueField"
                                                                      }
                                                                    ]
                                                                  },
                                                                  (v226/*: any*/),
                                                                  (v59/*: any*/)
                                                                ]
                                                              },
                                                              (v232/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "fieldSets(first:500)"
                                          },
                                          (v258/*: any*/),
                                          (v259/*: any*/),
                                          (v59/*: any*/)
                                        ]
                                      },
                                      (v59/*: any*/)
                                    ],
                                    "type": "JiraListRowConnection",
                                    "abstractKey": "__isJiraListRowConnection"
                                  },
                                  (v59/*: any*/)
                                ]
                              },
                              {
                                "alias": "issuesWithIssueSearchInput",
                                "args": (v255/*: any*/),
                                "filters": [
                                  "viewConfigInput",
                                  "fieldSetsInput",
                                  "scope",
                                  "settings",
                                  "issueSearchInput"
                                ],
                                "handle": "connection",
                                "key": "firstGroupSection_nativeIssueTable__issuesWithIssueSearchInput",
                                "kind": "LinkedHandle",
                                "name": "issues"
                              },
                              (v46/*: any*/),
                              (v54/*: any*/),
                              (v252/*: any*/),
                              (v49/*: any*/),
                              (v253/*: any*/),
                              (v251/*: any*/)
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "firstGroup",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "issuesWithIssueSearchInput",
                                    "args": (v255/*: any*/),
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v113/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v59/*: any*/),
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v245/*: any*/)
                      }
                    ]
                  },
                  {
                    "args": (v250/*: any*/),
                    "filters": (v247/*: any*/),
                    "handle": "connection",
                    "key": "IssueNavigatorJiraGroupedListViewPagination__groups",
                    "kind": "LinkedHandle",
                    "name": "groups",
                    "dynamicKey": (v248/*: any*/)
                  }
                ],
                "type": "JiraGroupedListView"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v260/*: any*/),
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                      (v100/*: any*/),
                      (v103/*: any*/),
                      (v104/*: any*/),
                      (v108/*: any*/),
                      (v109/*: any*/),
                      (v111/*: any*/),
                      (v112/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v126/*: any*/),
                              (v127/*: any*/),
                              (v239/*: any*/),
                              (v259/*: any*/),
                              (v258/*: any*/),
                              (v59/*: any*/)
                            ]
                          },
                          (v46/*: any*/),
                          (v240/*: any*/),
                          (v243/*: any*/),
                          (v59/*: any*/)
                        ],
                        "type": "JiraListRowConnection",
                        "abstractKey": "__isJiraListRowConnection"
                      },
                      (v244/*: any*/),
                      (v59/*: any*/),
                      (v246/*: any*/)
                    ]
                  },
                  {
                    "args": (v260/*: any*/),
                    "filters": (v247/*: any*/),
                    "handle": "connection",
                    "key": "IssueNavigatorJiraListViewPagination__issues",
                    "kind": "LinkedHandle",
                    "name": "issues",
                    "dynamicKey": (v248/*: any*/)
                  }
                ],
                "type": "JiraListView"
              }
            ]
          },
          {
            "args": (v261/*: any*/),
            "kind": "ScalarField",
            "name": "shouldShowAtlassianIntelligence"
          },
          {
            "args": (v262/*: any*/),
            "concreteType": "JiraUserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              (v59/*: any*/),
              {
                "kind": "ScalarField",
                "name": "jqlBuilderSearchMode"
              }
            ]
          },
          {
            "args": (v261/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianIntelligenceAction",
            "plural": false,
            "selections": [
              (v41/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAccessible"
                  }
                ],
                "type": "JiraAccessAtlassianIntelligenceFeature"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "link"
                  }
                ],
                "type": "JiraEnableAtlassianIntelligenceDeepLink"
              }
            ]
          },
          {
            "args": (v262/*: any*/),
            "concreteType": "JiraJqlFieldWithAliases",
            "kind": "LinkedField",
            "name": "rankField",
            "plural": false,
            "selections": [
              (v54/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/)
            ]
          },
          {
            "condition": "shouldQueryProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v35/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  (v87/*: any*/),
                  (v236/*: any*/),
                  {
                    "alias": "editIssues",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "EDIT_ISSUES"
                      }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": (v263/*: any*/),
                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                  },
                  {
                    "alias": "createIssues",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_ISSUES"
                      }
                    ],
                    "concreteType": "JiraProjectAction",
                    "kind": "LinkedField",
                    "name": "action",
                    "plural": false,
                    "selections": (v263/*: any*/),
                    "storageKey": "action(type:\"CREATE_ISSUES\")"
                  },
                  (v120/*: any*/),
                  (v45/*: any*/),
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraProjectCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "allowLocalFields"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "shouldQueryConditionalFormatting",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v36/*: any*/),
                            "concreteType": "JiraFormattingRuleConnection",
                            "kind": "LinkedField",
                            "name": "conditionalFormattingRules",
                            "plural": false,
                            "selections": (v75/*: any*/),
                            "storageKey": "conditionalFormattingRules(first:20)"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldQueryConditionalFormattingFromSavedView",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "condition": "shouldQueryConditionalFormatting",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v36/*: any*/),
                            "concreteType": "JiraFormattingRuleConnection",
                            "kind": "LinkedField",
                            "name": "conditionalFormattingRules",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraFormattingRuleEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraFormattingRule",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v45/*: any*/),
                                      (v77/*: any*/),
                                      (v73/*: any*/),
                                      (v72/*: any*/)
                                    ]
                                  },
                                  (v41/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "conditionalFormattingRules(first:20)"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v147/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6d6128157de23583fdf95be9b30eccb893f9fa157c7b8ceaebbc13444f031c50",
    "metadata": {},
    "name": "main_IssueNavigatorQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcpninjqlorderbyrankrelayprovider": isOrderByRankEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewenabledrelayprovider": isSavedListViewEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider": isSavedViewConditionalFormattingEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcnindecoupledjqlvalidationfieldrelayprovider": isNinDecoupledJqlValidationFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisNinIssuePreviewPanelChangeboardingEnabledRelayProvider": isNinIssuePreviewPanelChangeboardingEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisIssueSearchWarningsEnabled": isIssueSearchWarningsEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldd1relayprovider": isFormulaFieldD1Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcmimicflatlistrsswhileuninitialisedrelayprovider": isMimicFlatlistRssWhileUninitialisedEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinFieldCellExtractionRelayProvidertsx": isFieldCellExtractionEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcUseNodeIdForRowKeyDisabledRelayProvidertsx": isUseNodeIdForRowKeyDisabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJivColouredDueDateUiChangesRelayprovider": isColouredDueDateUiChangesEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcEmpanadaAssigneeAgentDelegateFixRelayprovider": shouldFetchDelegatorForList_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldFetchDelegator_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmSurfaceAgentAssigneeRelayProvider": shouldSurfaceAgentAssignee_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierFormulaFieldD2D3Relayprovider": isFrontierFormulaFieldD2D3Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraForgeCustomFieldsInIssueNavigatorEnabledrelayprovider": isJiraForgeCustomFieldsInIssueNavigatorEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcfrontierformulafieldninrelayprovider": isFrontierFormulaFieldNinEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": isJscInlineEditFastFollowsEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcissuetablecolorfieldrelayprovider": isColorFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIssueTableDateRangeFieldRelayProvider": isDateRangeFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcusenodeidforrowkeyrelayprovider": isUseNodeIdForRowKeyEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcassetscustomfieldslimitincreaserelayprovider": cmdbFirst_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNinCaterRichTextWithPlainTextRendererRelayProvidertsx": caterRichTextWithPlainTextRenderer_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcPrivateGoalsInJiraRelayProvider": isPrivateGoalsFieldReadEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcprojectsInJiraGaDropRelayProvider": isProjectsInJiraGaDropEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiraaiagentavatarsingleuserpickerninrelayprovider": isJiraAiAgentAvatarSingleUserPickerNINEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJiraSpreadsheetGroupSearchWarningsEnabled": isJiraSpreadsheetGroupSearchWarningsEnabled_provider,
      "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderprojectsinjiram1relayprovider": isProjectsInJiraM1Enabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider,
      "__relay_internal__pv__jiraissuetable__groupingsrcrelayproviderPrivateGoalsInJiraRelayProvider": isPrivateGoalsInListViewGroupHeaderEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcadditionalFieldsInGroupByProjectHeaderRelayProvider": isAdditionalFieldsInGroupByProjectHeaderEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcIsJSCExpandAllChangesEnabledRelayprovider": isJSCExpandAllChangesEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider": isPaidListNinMergeOnboardingModalEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcFrontierGuidedAutonomyEapRelayProvider": isGuidedAutonomyEapEnabled_provider
    }
  }
};
})();

(node as any).hash = "e145ed16d65bc2f06f9bb966f9bcbb46";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
